import { useId } from 'react'

/** Coin mark — tree inside a thin ring with slowly rotating circular type (site chrome, top-left). */
export function CoinMark({ className = '' }: { className?: string }) {
  return (
    <span className={`relative grid place-items-center rounded-full bg-paper ${className}`} aria-hidden>
      <svg viewBox="0 0 100 100" className="coin-spin absolute inset-0 h-full w-full">
        <defs>
          <path id="coin-arc" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" />
        </defs>
        <circle cx="50" cy="50" r="49" fill="none" stroke="currentColor" strokeOpacity="0.18" />
        <text fontSize="10.5" letterSpacing="3.2" fill="currentColor" fillOpacity="0.65" fontFamily="Inter, sans-serif">
          <textPath href="#coin-arc">REPTREE · TALENT · REPRESENTED ·</textPath>
        </text>
      </svg>
      <TreeMark className="h-[42%] w-[42%]" />
    </span>
  )
}

/** Rep·Tree wordmark — condensed, with a Stripe-style gradient tree mark between the words. */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center font-display font-light tracking-[-0.04em] ${className}`}>
      <span>Rep</span>
      <TreeMark className="mx-[0.06em] h-[1.06em] w-[1.06em]" />
      <span>Tree</span>
    </span>
  )
}

export function TreeMark({ className = '' }: { className?: string }) {
  // A UNIQUE gradient id per instance. Multiple TreeMarks render on one page (e.g. the auth split-screen
  // brand panel plus the mobile wordmark), and a shared id meant `url(#reptree-grad)` resolved to the FIRST
  // one in the DOM. On mobile that first copy sits in the `hidden md:flex` brand panel (display:none), whose
  // gradient does not paint, so the visible tree lost its stroke and vanished. A per-instance id fixes it.
  const gradId = `reptree-grad-${useId().replace(/:/g, '')}`
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="4" y1="46" x2="44" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#013220" />
          <stop offset="0.45" stopColor="#2FA36B" />
          <stop offset="0.75" stopColor="#50C878" />
          <stop offset="1" stopColor="#C9A46B" />
        </linearGradient>
      </defs>
      <g stroke={`url(#${gradId})`} strokeLinecap="round">
        <path d="M24 44V28" strokeWidth="2.6" />
        <g strokeWidth="2.1">
          <path d="M24 28L15 19M24 28l9-9" />
          <path d="M15 19l-6 6M15 19l6-6M33 19l6 6M33 19l-6-6" />
          <path d="M9 25l-3 3M9 25l3 3M21 13l-3-3M21 13l3-3M27 13l-3-3M27 13l3-3M39 25l-3 3M39 25l3 3" />
        </g>
      </g>
    </svg>
  )
}
